export default function ($filter) {
    return function (value) {
        if (value === undefined || value === null) {
            return 'N/A';
        }

        return $filter('date')(value, 'dd/MM/yyyy HH:mm');
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/filters/submitted.js